import { AssertException } from '../assert.exception';

export class AssertIsIntException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsIntException.prototype);
  }
}
